import React, { useEffect, useState } from 'react'
import { 
  useSupplierCategoryQuery, 
  useCreateSupplierCategoryMutation, 
  useSupplierCategoryByNameQuery, 
  useUpdateSupplierCategoryMutation, 
  useChangeSupplierStatusMutation, 
  useDeleteSupplierCategoryMutation, 
  useChangeSupplierCategoryStatusMutation
} from '../../../Store/Apis/supplierApis';
import Error from '../../../Components/Error/Error';
import Loader from '../../../Components/Loader/Loader';
import AddEditSupplierCategory from '../../../Components/AddEditSupplierCategory/AddEditSupplierCategory';
import toast from 'react-hot-toast';
import { Modal } from 'react-bootstrap';
import { Table } from 'antd';
import { useSelector } from 'react-redux';

const SuppliersCategory = () => {
  const user = useSelector((state) => state.auth.user);
  // page 1 for listing
  // page 2 for add
  // page 3 for edit
  const [page, setPage] = useState(1)
  const [sortFilter, setSortFilter] = useState({
    search: '',
    filter: '',
    outletID: ''
  });
  const getSuppliersCategoryApi = useSupplierCategoryQuery({
    keyword: sortFilter.search,
    outletID: sortFilter.outletID
  })

  
  const [createSupplierCategoryMutation] = useCreateSupplierCategoryMutation()

  // ADD METHODS
  const handleCreate = (formData) => {
    console.log(formData)
    createSupplierCategoryMutation({
      outletId: formData.outlet,
      categoryName: formData.categoryName,
      isActive: 1
    }).then((res) => {
      if (res?.data?.status === 200) {
        setPage(1)
        toast.success(res?.data?.message, { duration: 7000 });
      } else {
        toast.error(res?.data?.message, { duration: 7000 });
      }
    })
  } 


  // EDIT METHODS
  const [selectedEditId, setSelectedEditId] = useState()
  const supplierCategoryByNameQuery = useSupplierCategoryByNameQuery({
    keyword: selectedEditId
  }, {skip: !selectedEditId})
  const [updateSupplierCategoryMutation] = useUpdateSupplierCategoryMutation()

  const handleEdit = (formData) => {
    console.log(formData)
    updateSupplierCategoryMutation({
      id: formData.id,
      outletId: formData.outlet,
      categoryName: formData.categoryName,
      isActive: 1,
    }).then((res)=>{
      if (res?.data?.status === 200) {
        setPage(1)
        toast.success(res?.data?.message, { duration: 7000 });
      } else {
        toast.error(res?.data?.message, { duration: 7000 });
      }
    })
  } 


  // STAUS CHANGE
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [changeStatus] = useChangeSupplierCategoryStatusMutation()
  const handleChangeStatus = () => {
      changeStatus(selectedStatus).then((res)=>{
        console.log(res)
        setSelectedStatus(null)
      })
  }

  // DELETE
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [deleteCategory] = useDeleteSupplierCategoryMutation()
  const handleDelete = () => {
      deleteCategory(selectedRecord).then((res)=>{
        console.log(res)
        setSelectedRecord(null)
      })
  }


  useEffect(() => {
    if (user.role !== 'superAdmin') {
      setSortFilter({
        ...sortFilter,
        outletID: user.outletID
      });
    }    
  }, []);


  // ADD SUPPLIER VIEW
  if(page === 2){
    return(
      <div>
        <div className="row align-items-center justify-content-between mb-3">
          <div className="col">
            <h5 className="fw-500 text-white mb-0">Add Product Category</h5>
          </div>
          <div className="col-auto">
              <button 
                type='button'
                className="btn btn-icon btn-3 btn-white text-primary mb-0"
                onClick={()=> setPage(1)}
              >
                <i className="fa fa-arrow-left me-2"></i>  Back
              </button>
          </div>
        </div>
        <div className="card">
          <div className="card-body">
            <AddEditSupplierCategory handleSubmit={handleCreate} cancel={setPage} />
          </div>
        </div>
      </div>
    )
  }

  // EDIT SUPPLIER VIEW
  if(page === 3){
    return(
      <div>
        <div className="row align-items-center justify-content-between mb-3">
          <div className="col">
            <h5 className="fw-500 text-white mb-0">Edit Product Category</h5>
          </div>
          <div className="col-auto">
              <button 
                type='button'
                className="btn btn-icon btn-3 btn-white text-primary mb-0"
                onClick={()=> setPage(1)}
              >
                <i className="fa fa-arrow-left me-2"></i>  Back
              </button>
          </div>
        </div>
        <div className="card">
          <div className="card-body">
            {supplierCategoryByNameQuery.isError && <Error/>}
            {supplierCategoryByNameQuery.isFetching && <Loader height="500px"/>}
            {supplierCategoryByNameQuery.isLoading && <Loader height="500px"/>}
            {
                (supplierCategoryByNameQuery.isSuccess && !supplierCategoryByNameQuery.isFetching) && 
                <AddEditSupplierCategory handleSubmit={handleEdit} cancel={setPage} data={supplierCategoryByNameQuery?.data?.data[0]} />
                
            }
          </div>
        </div>
      </div>
    )
  }


  // Sort Functionality for Columns
  const columns = [
    {
      title: '#',
      dataIndex: 'id',
      key: 'id',
      render: (_, __, index) => index + 1,
    },
    {
      title: 'Product Category',
      dataIndex: 'categoryName',
      key: 'categoryName',
      sorter: (a, b) => a.categoryName.localeCompare(b.categoryName),
    },
    {
      title: 'Outlet',
      dataIndex: 'outletName',
      key: 'outletName',
    },
    {
      title: 'Status',
      dataIndex: 'isActive',
      key: 'isActive',
      render: (isActive, record) => (
        <button
          type="button"
          className={`btn badge badge-xs ${isActive === 1 ? 'badge-success' : 'badge-danger'} fw-600 text-xs`}
          onClick={() => setSelectedStatus({ keyID: record.id, isActive: isActive === 1 ? 0 : 1 })}
        >
          {isActive === 1 ? 'Active' : 'Deactive'}
        </button>
      ),
    },
    {
      title: 'Actions',
      key: 'actions',
      render: (_, record) => (
        <div className="d-flex gap-2">
          <button
            type="button"
            className="badge badge-xs badge-warning fw-600 text-xs btn"
            onClick={() => (setPage(3), setSelectedEditId(record.categoryName))}
          >
            Edit
          </button>
          <button
            type="button"
            className="btn badge badge-xs badge-danger text-xs fw-600"
            onClick={() => setSelectedRecord(record.id)}
          >
            Delete
          </button>
        </div>
      ),
    },
  ];


  return (
    <div>
      <div className="row align-items-center justify-content-between mb-3">
          <div className="col">
            <h5 className="fw-500 text-white mb-0">Product Category</h5>
          </div>
          <div className="col-auto">
              <button
                type='button' 
                className="btn btn-icon btn-3 btn-white text-primary mb-0"
                onClick={()=> setPage(2)}
              >
                <i className="fa fa-plus me-2"></i>  Add New Category
              </button>
          </div>
        </div>
      <div className="row">
        <div className="col-12">
          <div className="card mb-4">
            <div className="card-header p-4">
              <input 
                type="text" 
                class="form-control" 
                placeholder="Search by Product Category name"
                value={sortFilter?.search || ""}
                onChange={(e) => setSortFilter({...sortFilter, search: e.target.value})}  
              />
            </div>
            <div className="card-body p-0">
              {getSuppliersCategoryApi.isError && <Error/>}
              {getSuppliersCategoryApi.isLoading && <Loader height="500px"/>}
              {
                getSuppliersCategoryApi.isSuccess && (
                  <Table
                    dataSource={getSuppliersCategoryApi.data.data}
                    columns={columns}
                    rowKey={(record) => record.id}
                    pagination={{ pageSize: 10 }}
                  />
                )
              }
            </div>
          </div>
        </div>
      </div>


      {/* STATUS CHANGE MODAL */}
      <Modal 
            show={selectedStatus} 
            onHide={() => setSelectedStatus(null)} 
            size="sm" 
            centered
        >
            <Modal.Body className='text-center p-4'>
                <h5>Are you sure you want to change status?</h5>
                <div className="buttons d-flex gap-3 justify-content-center">
                    <button className='btn btn-danger bg-danger btn-sm mb-0' onClick={()=>(setSelectedStatus(null))}>Cancel</button>
                    <button className='btn btn-primary btn-sm mb-0' onClick={handleChangeStatus}>Confirm</button>
                </div>
            </Modal.Body>
        </Modal>

        {/* DELETE MODAL */}
        <Modal  
            show={selectedRecord} 
            onHide={() => setSelectedRecord(null)} 
            size="sm" 
            centered
        >
            <Modal.Body className='text-center p-4'>
                <h5>Are you sure you want to delete the brand?</h5>
                <div className="buttons d-flex gap-3 justify-content-center">
                    <button className='btn btn-danger bg-danger btn-sm mb-0' onClick={()=>(setSelectedRecord(null))}>Cancel</button>
                    <button className='btn btn-primary btn-sm mb-0' onClick={handleDelete}>Confirm</button>
                </div>
            </Modal.Body>
        </Modal>
    </div>
  )
}

export default SuppliersCategory